import { createSelector } from '@reduxjs/toolkit';

import type { IState } from '@/Module/Store/Model';

export const selectedSubscriptionPlanActiveSelector = createSelector(
  [(state: IState) => state.subscription.planList],
  planList => {
    return planList.filter(item => item.sortOrder === 150 || item.sortOrder === 200);
  },
);
